import { AppActionTypes } from '@console/actions/actionType';
import type { AppAction } from '@console/actions/actionType';
import type { LocalProject } from '@console/reducers/projects';
import type { Reducer } from 'react';
import { combineReducers } from 'redux';

const beginAt: Reducer<
  NonNullable<LocalProject['giftDistributionPeriod']>['beginAt'] | null,
  AppAction
> = (state = null, action) => {
  switch (action.type) {
    case AppActionTypes.GET_PROJECT_DETAIL_SUCCESS:
      return action.project.giftDistributionPeriod
        ? action.project.giftDistributionPeriod.beginAt
        : null;
    default:
      return state;
  }
};

const endAt: Reducer<
  NonNullable<LocalProject['giftDistributionPeriod']>['endAt'] | null,
  AppAction
> = (state = null, action) => {
  switch (action.type) {
    case AppActionTypes.GET_PROJECT_DETAIL_SUCCESS:
      return action.project.giftDistributionPeriod
        ? action.project.giftDistributionPeriod.endAt
        : null;
    default:
      return state;
  }
};

export const giftDistributionPeriod = combineReducers({
  beginAt,
  endAt
});
